export const OPERATOR_SKILL_OPTIONS = [
  'Hauler',
  'Loader',
  'Driller',
  'Grader',
  'Dozer',
] as const;

export const OPERATOR_EXPERIENCE_OPTIONS = [
  'Experienced',
  'Intermediate',
  'Beginner',
] as const;

export type OperatorExperience = (typeof OPERATOR_EXPERIENCE_OPTIONS)[number];

export const operatorSkillLabelKey = (skill: string): string =>
  `operator_skill_${skill.toLowerCase().replace(/\s+/g, '_')}`;

export const operatorExperienceLabelKey = (experience: string): string =>
  `operator_experience_${experience.toLowerCase()}`;

export const OPERATOR_HEADERS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  IS_ACTIVE: 'isActive',
  ROLE: 'role',
  SKILLS: 'skills',
  EXPERIENCE: 'experience',
} as const;

export type OperatorHeaderKey = keyof typeof OPERATOR_HEADERS;

export const REQUIRED_HEADERS: OperatorHeaderKey[] = [
  'FIRST_NAME',
  'LAST_NAME',
  'IS_ACTIVE',
];

export const TEMPLATE_SAMPLE_ROW: Record<OperatorHeaderKey, string> = {
  FIRST_NAME: 'Raju',
  LAST_NAME: 'Sharma',
  IS_ACTIVE: 'true',
  ROLE: 'driver',
  SKILLS: 'Hauler,Loader',
  EXPERIENCE: 'Experienced',
};

export const validateHeaders = (
  fileHeaders: string[]
): { valid: boolean; missing: string[] } => {
  const normalised = fileHeaders.map((h) =>
    h.trim().toUpperCase().replace(/ /g, '_')
  );
  const expectedUpper: Record<OperatorHeaderKey, string> = {
    FIRST_NAME: 'FIRSTNAME',
    LAST_NAME: 'LASTNAME',
    IS_ACTIVE: 'ISACTIVE',
    ROLE: 'ROLE',
    SKILLS: 'SKILLS',
    EXPERIENCE: 'EXPERIENCE',
  };
  const missing = REQUIRED_HEADERS.filter(
    (h) => !normalised.includes(expectedUpper[h]) && !normalised.includes(h)
  );
  return {
    valid: missing.length === 0,
    missing: missing.map((h) => OPERATOR_HEADERS[h]),
  };
};
